import axios from "axios";
export default class ApiExtraServiceDetails {
    static async GetExtraServiceDetailsList(session_uuid) {
        try {
            const response = await axios.get("/api/admin/extra-service-details/get-list", {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return response.data.response;
        }
        catch (e) {
            return false;
        }
    }
    static async ForceRefreshBSSExtraServices(session_uuid) {
        try {
            const response = await axios.post("/api/admin/extra-service-details/refresh", {}, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return response.data.response;
        }
        catch (e) {
            return false;
        }
    }
    static async GetExtraServiceDetailsByUUID(session_uuid, uuid) {
        try {
            const result = await axios.post("/api/admin/extra-service-details/get-service", {
                uuid: uuid,
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.response;
        }
        catch (e) {
            return false;
        }
    }
    static async EditExtraServiceDetails(session_uuid, uuid, price_for, act_price_for, name_it, name_en, price_eur, act_price_eur, other_texts) {
        try {
            const result = await axios.post("/api/admin/extra-service-details/edit", {
                uuid: uuid,
                price_for: price_for,
                act_price_for: act_price_for,
                name_it: name_it,
                name_en: name_en,
                price_eur: price_eur,
                act_price_eur: act_price_eur,
                other_texts: other_texts,
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.response;
        }
        catch (e) {
            return false;
        }
    }
}
